<template>
  <div class="chatResponse-container">
    <div class="title-box">
      <div class="title-logo"></div>
      <div class="title-txt">搜索结果</div>
    </div>

    <div class="img-connected">
      <search-topo @changeList="changeList"></search-topo>
    </div>

    <div class="img-list">
      <div class="img-item" v-for="item in info">
        <div class="img-item-title">{{item.title}}</div>
        <div class="img-item-value">{{item.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chatResponse",
  data() {
    return {
      info: [
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090基于cvdID909090基于cvdID909090基于cvdID909090基于cvdID909090基于cvdID909090"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"},
        {title: "cvdID9090", value: "基于cvdID909090********"}
      ]
    };
  },
  methods: {
    changeList(val) {
      console.log(val);
    }
  }
};
</script>

<style scoped lang="less">
.chatResponse-container {
  display: block;
  text-align: left;
  width: 993px;
  height: 588px;
  position: absolute;
  top: 20px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 5px;
  z-index: 10;
}
.title-box {
  .title-logo {
    background-image: url("../assets/img/ask_logo.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 53px;
    width: 59px;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .title-txt {
    background-image: url("../assets/img/ask_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    color: rgba(241, 237, 255, 1);
    font-family: "YouSheBiaoTiHei";
    font-size: 24px;
    height: 54px;
    width: 260px;
    line-height: 54px;
    position: absolute;
    left: 79px;
    top: 15px;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
    padding-left: 20px;
  }
}
.img-connected {
  position: absolute;
  top: 90px;
  left: 20px;
  width: 612px;
  height: 470px;
  //background-color: #00F0FF;
}
.img-list {
  padding: 5px;
  position: absolute;
  top: 13px;
  left: 657px;
  width: 297px;
  height: 547px;
  overflow-y: auto;
  overflow-x: hidden;
  .img-item {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    line-height: 30px;
    padding: 1px;
    width: 100%;
    border: 1px solid transparent;
    border-image: linear-gradient(to right, #9F9EF2, #9F9EF2) 1;
    .img-item-title {
      color: #9F9EF2;
      width: 82px;
      margin: 0 auto;
    }
    .img-item-value {
      color: #FFFFFF;
      width: 163px;
      word-wrap:break-word;
      margin: 0 auto;
      display: -webkit-box; /* 必须使用此值 */
      -webkit-line-clamp: 3; /* 限制为两行 */
      -webkit-box-orient: vertical; /* 垂直方向显示 */
      overflow: hidden; /* 隐藏超出的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
  }
  .img-item:nth-child(2n) {
    border: none;
  }
}
.img-list::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

.img-list::-webkit-scrollbar-thumb {
  background-color: #757ebe; /* 滚动条的颜色 */
  border-radius: 4px; /* 让滚动条块稍微圆角 */
}

.img-list::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条背景透明 */
}
</style>
